/**
 * Shared assets from the platform: the brand fonts and the favicon.
 *
 * Attached at runtime rather than linked in index.html, because Vite prepends
 * `base` to root-relative URLs in HTML — /_assets/... would become
 * /wheelilbin/_assets/... and 404 in dev and in the built bundle alike.
 *
 * nginx serves /_assets in production; `make web-dev` proxies it.
 */

const ASSETS = '/_assets'

let attached = false

export function attachSharedAssets(): void {
  if (attached) return
  attached = true

  // Preload the two faces the first viewport actually uses. Without this the
  // browser cannot discover them until fonts.css has parsed, and the LCP
  // element is a Michroma heading — so the paint waits on a request that had
  // not started yet.
  for (const file of ['michroma-latin-400-normal', 'montserrat-latin-400-normal']) {
    const preload = document.createElement('link')
    preload.rel = 'preload'
    preload.as = 'font'
    preload.type = 'font/woff2'
    preload.crossOrigin = 'anonymous'
    preload.href = `${ASSETS}/fonts/${file}.woff2`
    document.head.append(preload)
  }

  const fonts = document.createElement('link')
  fonts.rel = 'stylesheet'
  fonts.href = `${ASSETS}/fonts/fonts.css`
  document.head.append(fonts)

  const favicon = document.createElement('link')
  favicon.rel = 'icon'
  favicon.type = 'image/svg+xml'
  favicon.href = `${ASSETS}/brand/favicon.svg`
  document.head.append(favicon)
}
